import { Component } from 'react'
import '!style-loader!css-loader!emoji-mart/css/emoji-mart.css'
import 'components/features/pfm/EmojiPicker/EmojiPicker.styl'
import { Picker, BaseEmoji } from 'emoji-mart'

type EmojiPickerProps = {
  onSelect: (emoji: string) => void
}

class EmojiPicker extends Component<EmojiPickerProps> {
  render () {

    return (
      <Picker
        autoFocus
        native
        showPreview={ false }
        title=''
        onSelect={ this.handleSelect }
      />
    )
  }

  private handleSelect = (event: BaseEmoji) => {
    const { onSelect } = this.props
    onSelect(event.native)
  }
}

export default EmojiPicker
